/** One answer of a signup select: the value it stores and the translation key it shows. */
export interface FieldOption<V> {
  value: V;
  label: string;
}

export const YES_NO_OPTIONS: readonly FieldOption<boolean>[] = [
  { value: true, label: "common.yes" },
  { value: false, label: "common.no" },
];

/** One option per enum value, labelled `{labelPrefix}.{value}` as the signup translations key them. */
export function enumOptions<V extends string>(
  values: Record<string, V>,
  labelPrefix: string
): FieldOption<V>[] {
  return Object.values(values).map((value) => ({
    value,
    label: `${labelPrefix}.${value}`,
  }));
}
